const LABELS = {
    sq: {
        form: {
            title: 'Kërkimi i Biznesit',
            subtitle: 'Plotësoni fushat për të filtruar rezultatet',
            resetTooltip: 'Pastro formularin',
            advancedToggle: 'Kërkim i avancuar',
            submit: 'KËRKO',
            emriBiznesit: 'Emri',
            emriBiznesitPlaceholder: 'Emri i biznesit ose emri tregtar',
            nui: 'NUI',
            nuiPlaceholder: 'Numri unik identifikues ose numri i biznesit',
            nrPersonal: 'ID e pronarit / të autorizuarit / bordit',
            komuna: 'Komuna',
            sektori: 'Sektori',
            aktivitetiKryesor: 'Aktiviteti kryesor',
            numriFiskal: 'Numri fiskal',
            aktivitetetTjera: 'Aktivitetet tjera',
            ndryshimiTipit: 'Ndryshimi i formës së biznesit',
            formaBiznesit: 'Forma e biznesit',
            pronesia: 'Pronësia',
            pronesiaLegend: 'Kërkimi sipas të dhënave të pronësisë',
            perqindjaHuaj: 'Përqindja e pronësisë së huaj',
            shteti: 'Shteti',
            komunaPronarit: 'Komuna e pronarit',
            emerPronari: 'Emri i pronarit / pronarit juridik / përfaqësuesit / bordit',
            mbiemriPronarit: 'Mbiemri i pronarit / pronarit juridik / përfaqësuesit / bordit',
            statusi: 'Statusi i biznesit',
            numriNjesise: 'Numri i njësisë',
            numriNjesiveTeRegjistruara: 'Numri i njësive të regjistruara',
            emriVjeter: 'Emri i vjetër i biznesit',
            emriVjeterPlaceholder: 'Emri i mëparshëm i biznesit',
            email: 'Email',
            emailPlaceholder: 'Email i biznesit',
            telefoni: 'Telefoni',
            telefoniPlaceholder: 'Numri i telefonit',
            adresa: 'Adresa / rruga',
            adresaPlaceholder: 'Adresa ose rruga',
            vitiThemelimit: 'Viti i themelimit',
            vitiShuarjes: 'Viti i shuarjes',
            vitiNdryshimit: 'Viti i ndryshimit të fundit',
            yearPlaceholder: 'Zgjedh vitin...',
            kontaktiLegend: 'Kërkimi sipas të dhënave të kontaktit dhe adresës',
            pronariLegend: 'Kërkimi sipas të dhënave të pronarëve, drejtorëve, të autorizuarve, anëtarëve të bordit',
            numriPuntoreve: 'Numri i punëtorëve',
            numriPuntorevePlaceholder: 'Numri i punëtorëve',
            institucioni: 'Institucioni',
            institucioniPlaceholder: 'Zgjedh institucionin',
            vitetLegend: 'Kërkimi sipas të dhënave të vitit',
            teDhenatShteseLegend: 'Kërkimi sipas të dhënave shtesë të biznesit',
            selectPlaceholder: 'Zgjedh...',
            validationError: 'Ju lutem plotësoni të paktën një fushë',
            networkError: 'Gabim në rrjet ose server. Provoni përsëri.',
            verificationLoading: 'Verifikimi po ngarkohet. Provoni përsëri.',
            verificationFailed: 'Verifikimi dështoi. Provoni përsëri.',
        },
        results: {
            sectionTitle: 'Rezultatet e Bizneseve',
            countBanner: (shown, total) => `Në listën në vijim janë paraqitur ${shown} nga ${total} rezultate në kërkimin tuaj.`,
            refineHint: 'Për të marrë rezultate më specifike, ju lutem vendosni kritere shtesë në kërkim.',
            empty: 'Nuk u gjet asnjë biznes për kriteret e dhëna.',
            columns: {
                emri: 'Emri',
                emriTregtar: 'Emri tregtar',
                nui: 'NUI',
                komuna: 'Komuna',
                llojiBiznesit: 'Lloji biznesit',
                statusi: 'Statusi',
                njesite: 'Njësitë',
            },
            ndryshimiTipit: 'Ndryshimi i formës së biznesit',
            groupOwners: 'Pronarët',
            groupReps: 'Përfaqësuesit',
            groupBordi: 'Bordi',
            groupContact: 'Kontakti',
            email: 'Email',
            sektori: 'Sektori',
            numriPuntoreve: 'Numri i punëtorëve',
            noOwners: 'Nuk ka pronarë të regjistruar.',
            noReps: 'Nuk ka përfaqësues të regjistruar.',
            noBordi: 'Nuk ka bord të regjistruar.',
            showMorePersons: (n) => `+${n} të tjerë`,
            showLessPersons: 'Më pak',
            statusLabel: 'Statusi',
            units: (n) => `${n} njësi`,
            sortLabel: 'Rendit sipas',
            established: 'Themeluar',
            passive: 'Pasivizuar',
            closed: 'Shuar',
            rowDetails: 'Shih detajet e biznesit',
        },
    },
    en: {
        form: {
            title: 'Business Search',
            subtitle: 'Fill in fields to filter results',
            resetTooltip: 'Reset search form',
            advancedToggle: 'Advanced search',
            submit: 'SEARCH',
            emriBiznesit: 'Name',
            emriBiznesitPlaceholder: 'Business name or trade name',
            nui: 'UIN',
            nuiPlaceholder: 'Unique Identification Number or business number',
            nrPersonal: 'Owner`s / Authorizer`s / Board ID',
            komuna: 'Municipality',
            sektori: 'Sector',
            aktivitetiKryesor: 'Main Activity',
            numriFiskal: 'Fiscal Number',
            aktivitetetTjera: 'Other Activities',
            ndryshimiTipit: 'Change of business form',
            formaBiznesit: 'Business Form',
            pronesia: 'Ownership',
            pronesiaLegend: 'Search by ownership data',
            perqindjaHuaj: 'Foreign ownership percentage',
            shteti: 'State',
            komunaPronarit: 'Municipality of the Owner',
            emerPronari: 'Name of owner / legal owner / representative / board',
            mbiemriPronarit: 'Surname of owner / legal owner / representative / board',
            statusi: 'Business Status',
            numriNjesise: 'Unit Number',
            numriNjesiveTeRegjistruara: 'Number of Registered Units',
            emriVjeter: 'Old Business Name',
            emriVjeterPlaceholder: 'Previous business name',
            email: 'Email',
            emailPlaceholder: 'Business email',
            telefoni: 'Phone',
            telefoniPlaceholder: 'Phone number',
            adresa: 'Address / Street',
            adresaPlaceholder: 'Address or street',
            vitiThemelimit: 'Year of Establishment',
            vitiShuarjes: 'Year of Closure',
            vitiNdryshimit: 'Year of last change',
            yearPlaceholder: 'Select year...',
            kontaktiLegend: 'Search by contact and address data',
            pronariLegend: 'Search by owner, director, authorized person and board member data',
            numriPuntoreve: 'Number of employees',
            numriPuntorevePlaceholder: 'Number of employees',
            institucioni: 'Institution',
            institucioniPlaceholder: 'Select institution',
            vitetLegend: 'Search by year data',
            teDhenatShteseLegend: 'Search by additional business data',
            selectPlaceholder: 'Select...',
            validationError: 'Please fill in at least one field',
            networkError: 'Network or server error. Please try again.',
            verificationLoading: 'Verification is loading. Please try again.',
            verificationFailed: 'Verification failed. Please try again.',
        },
        results: {
            sectionTitle: 'Business Results',
            countBanner: (shown, total) => `The list below shows ${shown} of ${total} results for your search.`,
            refineHint: 'To get more specific results, please add extra search criteria.',
            empty: 'No business was found for the given criteria.',
            columns: {
                emri: 'Name',
                emriTregtar: 'Trade Name',
                nui: 'UIN',
                komuna: 'Municipality',
                llojiBiznesit: 'Business type',
                statusi: 'Status',
                njesite: 'Units',
            },
            ndryshimiTipit: 'Business form change',
            groupOwners: 'Owners',
            groupReps: 'Representatives',
            groupBordi: 'Board',
            groupContact: 'Contact',
            email: 'Email',
            sektori: 'Sector',
            numriPuntoreve: 'Number of employees',
            noOwners: 'No registered owners.',
            noReps: 'No registered representatives.',
            noBordi: 'No registered board members.',
            showMorePersons: (n) => `+${n} more`,
            showLessPersons: 'Show less',
            statusLabel: 'Status',
            units: (n) => `${n} ${n === 1 ? 'unit' : 'units'}`,
            sortLabel: 'Sort by',
            established: 'Established',
            passive: 'Passivated',
            closed: 'Closed',
            rowDetails: 'View business details',
        },
    },
    sr: {
        form: {
            title: 'Pretraga biznisa',
            subtitle: 'Popunite polja za filtriranje rezultata',
            resetTooltip: 'Resetuj formular pretrage',
            advancedToggle: 'Napredna pretraga',
            submit: 'PRETRAGA',
            emriBiznesit: 'Naziv',
            emriBiznesitPlaceholder: 'Naziv biznisa ili trgovačko ime',
            nui: 'JMB',
            nuiPlaceholder: 'Jedinstveni matični broj ili broj biznisa',
            nrPersonal: 'ID Vlasnika / Ovlaštenika / Odbora',
            komuna: 'Opština',
            sektori: 'Sektor',
            aktivitetiKryesor: 'Glavna Aktivnost',
            numriFiskal: 'Fiskalni Broj',
            aktivitetetTjera: 'Ostale Aktivnosti',
            ndryshimiTipit: 'Promena oblika poslovanja',
            formaBiznesit: 'Oblik biznisa',
            pronesia: 'Vlasništvo',
            pronesiaLegend: 'Pretraga po podacima o vlasništvu',
            perqindjaHuaj: 'Procenat stranog vlasništva',
            shteti: 'Država',
            komunaPronarit: 'Opština e Vlasnika',
            emerPronari: 'Ime vlasnika / zakonskog vlasnika / predstavnika / odbora',
            mbiemriPronarit: 'Prezime vlasnika / zakonskog vlasnika / predstavnika / odbora',
            statusi: 'Status biznisa',
            numriNjesise: 'Broj jedinice',
            numriNjesiveTeRegjistruara: 'Broj registrovanih jedinica',
            emriVjeter: 'Stari naziv biznisa',
            emriVjeterPlaceholder: 'Prethodni naziv biznisa',
            email: 'Email',
            emailPlaceholder: 'Email biznisa',
            telefoni: 'Telefon',
            telefoniPlaceholder: 'Broj telefona',
            adresa: 'Adresa / Ulica',
            adresaPlaceholder: 'Adresa ili ulica',
            vitiThemelimit: 'Godina osnivanja',
            vitiShuarjes: 'Godina zatvaranja',
            vitiNdryshimit: 'Godina poslednje promene',
            yearPlaceholder: 'Izaberite godinu...',
            kontaktiLegend: 'Pretraga po podacima o kontaktu i adresi',
            pronariLegend: 'Pretraga po podacima o vlasnicima, direktorima, ovlaštenim licima i članovima odbora',
            numriPuntoreve: 'Broj zaposlenih',
            numriPuntorevePlaceholder: 'Broj zaposlenih',
            institucioni: 'Institucija',
            institucioniPlaceholder: 'Izaberite instituciju',
            vitetLegend: 'Pretraga po podacima o godini',
            teDhenatShteseLegend: 'Pretraga po dodatnim podacima o biznisu',
            selectPlaceholder: 'Izaberite...',
            validationError: 'Molimo popunite najmanje jedno polje',
            networkError: 'Greška mreže ili servera. Pokušajte ponovo.',
            verificationLoading: 'Verifikacija se učitava. Pokušajte ponovo.',
            verificationFailed: 'Verifikacija nije uspela. Pokušajte ponovo.',
        },
        results: {
            sectionTitle: 'Poslovni rezultati',
            countBanner: (shown, total) => `Lista u nastavku prikazuje ${shown} od ${total} rezultata vaše pretrage.`,
            refineHint: 'Za preciznije rezultate, dodajte dodatne kriterijume pretrage.',
            empty: 'Nijedan biznis nije pronađen za date kriterijume.',
            columns: {
                emri: 'Ime',
                emriTregtar: 'Trgovačko Ime',
                nui: 'JMB',
                komuna: 'Opština',
                llojiBiznesit: 'Poslovni tip',
                statusi: 'Status',
                njesite: 'Jedinice',
            },
            ndryshimiTipit: 'Promena oblika biznisa',
            groupOwners: 'Vlasnici',
            groupReps: 'Predstavnici',
            groupBordi: 'Odbor',
            groupContact: 'Kontakt',
            email: 'Email',
            sektori: 'Sektor',
            numriPuntoreve: 'Broj zaposlenih',
            noOwners: 'Nema registrovanih vlasnika.',
            noReps: 'Nema registrovanih predstavnika.',
            noBordi: 'Nema registrovanih članova odbora.',
            showMorePersons: (n) => `+${n} više`,
            showLessPersons: 'Manje',
            statusLabel: 'Status',
            units: (n) => `${n} ${n === 1 ? 'jedinica' : 'jedinice'}`,
            sortLabel: 'Sortiraj po',
            established: 'Osnovan',
            passive: 'Pasivizovan',
            closed: 'Ugašen',
            rowDetails: 'Pogledaj detalje biznisa',
        },
    },
};

export default function getLabels(locale) {
    return LABELS[locale] || LABELS.sq;
}
